// templateEngine(template, object)
var templateEngine = function (html, options) {
  // TODO Integrate var code into test suite
  var re = /@%([^%]+)?%@/g;
  var reExp = /(^( )?(if|for|else|switch|case|break|{|}))(.*)?/g;
  var code = "var r=[];\n";
  var cursor = 0;
  var match;

  var add = function (line, js) {
    js
      ? (code += line.match(reExp) ? line + "\n" : "r.push(" + line + ");\n")
      : (code +=
          line != "" ? 'r.push("' + line.replace(/"/g, '\\"') + '");\n' : "");
    return add;
  };

  while ((match = re.exec(html))) {
    // TODO update 'Object.keys.indexOf' to 'key in object'
    if (Object.keys(options).indexOf(match[1].slice(5)) > -1) {
      add(html.slice(cursor, match.index))(match[1], true);
      cursor = match.index + match[0].length;
    } else console.log("template engine: missing key:", match[1].slice(5));
  }

  add(html.substr(cursor, html.length - cursor));

  code += 'return r.join("");';

  return new Function(code.replace(/[\r\t\n]/g, "")).apply(options);
};

// var template = `<p>Dear @%this.name%@, we have completed your tax preparation for the year @%this.year_end__c%@.</p>`;
// var client = {
//     year_end__c: '12/31',
//     name: 'Name'
// }
// console.log(templateEngine(template, client));

module.exports = templateEngine;



//////////////////
// WEBPACK FOOTER
// ./utils/templateEngine.js
// module id = 1319
// module chunks = 0